// test48
(48 && 0);
